//zh.js
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const zh = {
  resultCodeInfo: {
    "200": "操作成功",
    "205": "用户登出成功",
    "500": "操作失败",
    "401": "暂未登录或token已经过期",
    "402": "用户名或密码错误",
    "403": "没有相关权限",
    "404": "参数检验失败",
    ERRCODE_001: "当前用户不可用",
    ERRCODE_002: "序列号过期",
    ERRCODE_003: "序列号不正确",
    EXPORTCODE: "无可导出数据",
    "999": "操作失败！请联系管理员",
  },
  verify: {
    dragTips: "请按住滑块，拖动到最右边",
    successTips: "完成验证"
  },
  login: {
    platformName: "HRP综合门户平台",
    usernamePlaceholder: "请输入用户名",
    usernameRule: "用户名必须在2~10位之间",
    passwordPlaceholder: "请输入密码",
    passwordRule: "密码必须在6~10位之间",
    phonePlaceholder: "请输入手机号",
    phoneRule: "请输入正确的手机号",
    verificationCodePlaceholder: "请输入验证码",
    verificationCodeRule: "请输入正确的验证码",
    loginButton: "登录",
    loginByPhone: "使用手机号登录",
    loginByUsername: "使用用户名密码登录",
    forgotPassword: "忘记密码?",
    privacyPolicy: "《隐私政策》",
    agreePrivacy: "点击登录即视为同意",
    register: "用户注册入口",
    verifyFirst: "请先进行验证",
    pleaseEnterUsername: "请输入用户名",
    pleaseEnterPassword: "请输入密码",
    pleaseEnterPhone: "请输入手机号",
    sendVerificationCode: "发送验证码",
    browserSupport: "本网站不支持IE浏览器，支持浏览器如下：",
    browserNote: "360、QQ、搜狗等浏览器请使用极速模式",
    google: "谷歌",
    firefox: "火狐",
    edge: "Edge",
    opera: "Opera",
    thirdPartyLogin: "第三方快捷登录",
    feedbackBox: "院长意见箱"
  },
  common: {
    switchLang: "Switch To English",
    // 通用按钮
    addBtn: "新增",
    editBtn: "编辑",
    deleteBtn: "删除",
    searchBtn: "查询",
    resetBtn: "重置",
    cancelBtn: "取消",
    closeBtn: "关闭",
    saveBtn: "保存",
    submitBtn: "提交",
    exportBtn: "导出",
    confirmBtn: "确定",
    returnBtn: "返回",
    // 是/否
    yes: "是",
    no: "否",
    // 通用标签
    tableSortNum: "序号",
    operation: "操作",
    select: "请选择",
    // 通用状态
    normalState: "正常",
    stopState: "停用",
    enable: "启用",
    disable: "禁用",
    all: "全部",
    allOption: "--全部--",
    // 通用提示
    tips: "提示",
    confirmDelete: "是否确认删除？",
    deleteTitle: "确认信息",
    // 操作成功/失败提示
    delSuccess: "删除成功",
    delFail: "删除失败",
    addSuccess: "添加成功",
    addFail: "添加失败",
    cancelSuccess: "取消成功",
    cancelFail: "取消失败",
    editSuccess: "编辑成功",
    editFail: "编辑失败",
    saveSuccess: "保存成功",
    saveFail: "保存失败",
    operationSuccess: "操作成功",
    operationFail: "操作失败",
    // 表单验证
    message: {
      mustInput: "此项必填",
      mustChoose: "此项必选",
    },
    ruleBlurMsg: "请输入",
    ruleSelectMsg: "请选择",
    // 其他
    popoverTitle: "显示列筛选",
    searchFailMsg: "查询信息不存在",
    updator: "更新者",
    updateAt: "更新时间",
    creator: "创建者",
    createAt: "创建时间",
    gobackLevel: "返回上一级",
  },
  ...zhLocale,
};
export default zh;
